import { BillingNote } from './billingNote';

export class CnRequestWrapper {
    
    id: string;
    amount: String;
    billingNotes: BillingNote[] = [];
    remark: string;
}